module.exports = __webpack_public_path__ + "img/modal2.a2c9f37f.jpg";